import React, {Component} from "react";
import SimpleDataTable from "../../../modules/SimpleDataTable";
import SimpleInput from "../../../modules/SimpleInput";
import {reSignedNumeric} from "../../common/Constants";
import { defaultTableChange } from "../../../modules/custom/customTable";

const DATA_NAME = "tentative1";

class PoTent1Table extends Component {
    constructor(props) {
      super(props);
      this.state = {
        pagination: {
          limit: 5,
          page: 1,
        },
      };
    }

    tableColumns = [
        {
            name: "",
            label: "No",
            options: {
                customBodyRender: (_, {rowIndex}) => <>{rowIndex + 1}</>,
                setCellHeaderProps: () => ({
                    style: {
                        width: "40px",
                        position: "sticky",
                        left: "0px",
                        background: "white",
                        zIndex: 102,
                    },
                }),
                setCellProps: () => ({
                    style: {
                        width: "40px",
                        position: "sticky",
                        left: "0px",
                        background: "white",
                        zIndex: 2,
                    },
                }),
            },
        },
        {
            name: "namaVariant",
            label: "Nama Unit",
            options: {
                customBodyRender: (value, {rowIndex}) => {
                  const kodeVariant = this.props.data[rowIndex]?.kodeVariant
                  return `${kodeVariant} - ${value}`;
                },
                setCellHeaderProps: () => ({
                    style: {
                        minWidth: "100px",
                        position: "sticky",
                        left: "50px",
                        background: "white",
                        zIndex: 102,
                    },
                }),
                setCellProps: () => ({
                    style: {
                        minWidth: "100px",
                        position: "sticky",
                        left: "50px",
                        background: "white",
                        zIndex: 2,
                    },
                }),
            },
        },
        {
            name: "namaWarna",
            label: "Warna",
            options: {
                setCellHeaderProps: () => ({
                    style: {
                        minWidth: "100px",
                        position: "sticky",
                        left: "180px",
                        background: "white",
                        zIndex: 102,
                    },
                }),
                setCellProps: () => ({
                    style: {
                        minWidth: "100px",
                        position: "sticky",
                        left: "180px",
                        background: "white",
                        zIndex: 2,
                    },
                }),
            },
        },
        {
            name: "sisaStokAfterFix",
            label: "Sisa Stock After Fix",
            options: {
                setCellProps: () => ({
                    style: {
                        minWidth: "100px",
                    },
                }),
            },
        },
        {
            name: "targetSalesTentative1",
            label: "Target Sales Tent.1",
            options: {
                customBodyRender: (val, {rowIndex}) => (
                    <SimpleInput
                        id="input_text_target_sales"
                        name="targetSalesTentative1"
                        containerclassname="margin-bottom-none"
                        value={val}
                        onChange={({target}) => {
                            if (reSignedNumeric.test(target.value)) {
                                this.props.onValueChange(DATA_NAME, rowIndex, target.name, target.value);
                            }
                        }}
                    />
                ),
                setCellProps: () => ({
                    style: {
                        minWidth: "100px",
                    },
                }),
            },
        },
        {
            name: "salesDayTentative1",
            label: "Sales/Day Tent.1",
            options: {
                setCellProps: () => ({
                    style: {
                        minWidth: "100px",
                    },
                }),
            },
        },
        {
            name: "sisaStokTentative1",
            label: "Sisa Stok Tent.1",
            options: {
                setCellProps: () => ({
                    style: {
                        minWidth: "100px",
                    },
                }),
            },
        },
        {
            name: "stockDayTentative1",
            label: "Stock Days Tent.1",
            options: {
                setCellProps: () => ({
                    style: {
                        minWidth: "100px",
                    },
                }),
            },
        },
        {
            name: "delta",
            label: "Delta",
            options: {
                setCellProps: () => ({
                    style: {
                        minWidth: "100px",
                    },
                }),
            },
        },
        {
            name: "qtyPoTentative1Recommended",
            label: "PO Tent.1 Recommended",
            options: {
                setCellProps: () => ({
                    style: {
                        minWidth: "150px",
                    },
                }),
            },
        },
        {
            name: "qtyPoTentative1Real",
            label: "PO Tent.1 Real",
            options: {
                customBodyRender: (val, {rowIndex}) => (
                    <SimpleInput
                        id="input_text_qty_po_real"
                        name="qtyPoTentative1Real"
                        containerclassname="margin-bottom-none"
                        value={val}
                        onChange={({target}) => {
                            if (reSignedNumeric.test(target.value)) {
                                this.props.onValueChange(DATA_NAME, rowIndex, target.name, target.value);
                            }
                        }}
                    />
                ),
                setCellProps: () => ({
                    style: {
                        minWidth: "150px",
                    },
                }),
            },
        },
    ];

    handleChangePage = (tableState) => {
      this.setState((prevValue) => ({
        ...prevValue,
        pagination: {
          ...prevValue.pagination,
          page: tableState.page + 1,
        },
      }));
    };

    handleRowsPerPage = (tableState) => {
      this.setState((prevValue) => ({
        ...prevValue,
        pagination: {
          ...prevValue.pagination,
          page: 1,
          limit: tableState.rowsPerPage,
        },
      }));
    };

    render() {
        return (
            <SimpleDataTable
                key={`${this.props.data?.length}-${this.state.pagination.page}`}
                data={this.props.data}
                columns={this.tableColumns}
                toCount={this.props.data?.length}
                rowsPerPage={this.state.pagination.limit}
                page={this.state.pagination.page - 1}
                options={{...defaultTableChange(this.handleChangePage, this.handleRowsPerPage), serverSide: false}}
            />
        );
    }
}

export default PoTent1Table;
